import { CreateWorkspace } from "common/components/CreateWorkspace";
import { Button } from "common/components/ui/Button";
import { useAuth } from "common/context/AuthContext";
import { getWhitelabelCustomization } from "common/helpers/utils";

import CreateWorkspaceImage from "assets/images/create-workspace.webp";

function NoWorkspaces() {
  const { whitelabelCustomization } = getWhitelabelCustomization();
  const { logout } = useAuth();

  return (
    <div className="flex flex-col max-w-[448px] m-auto">
      {whitelabelCustomization ? (
        <>
          <img src={CreateWorkspaceImage} alt="" height={254} />
          <h1 className="text-xl-bold text-center mb-2 mt-4">
            You do not have access to any workspaces
          </h1>
          <p className="text-center text-sm text-black-500 mb-6">
            If you think this is a mistake, please contact your administrator
          </p>
          <Button onClick={logout} className="mx-auto">
            Logout
          </Button>
        </>
      ) : (
        <CreateWorkspace isDialog={false} />
      )}
    </div>
  );
}

export default NoWorkspaces;
